export const calculateAge = (dateOfBirth, min) => {
  const dob = new Date(dateOfBirth);
  const ageInMs = Date.now() - dob.getTime();
  const ageInYears = Math.floor(ageInMs / 31556952000); // 31556952000 is the number of milliseconds in a year
  if (ageInYears < min) {
    return false;
  } else return true;
};

export const validateValue = (value, regex = null) => {
    if (value.trim() === "") { return true; }
    // If regex is provided, test the value against the regex
    if (regex && !regex.test(value)) { return true; }
    // If all checks pass
    return false;
};